import { container } from '@graphistry/falcor-react-redux';
import { ButtonList, ButtonListItem, ButtonListItems } from '@graphistry/viz/src/components/toolbar';
import { createLogger } from '@graphistry/common/logger';
const logger = createLogger(__filename);


const ToolbarItem = container({
    renderLoading: false,
    fragment: () => {
        //console.debug('@ToolbarItem::fragment');
        return `{ id, name, type, enabled, selected, timeoutMS, items: { length, mode, dropdownVisible, selected } }`;
    },
    mapFragment: (item, { selectToolbarItem, flags, user, keplerMode, keplerDropdownVisible, collectionsCount }) => {
        const mode = item.id === 'toggle-kepler-dropdown' ? (keplerMode || 'graph') : ((item && item.items && item.items.mode) || 'graph');
        const buttonLabel = mode === 'graph' ? 'Graph' : (mode === 'hybrid' ? 'Graph + Map' : 'Map');
        const dropdownVisible = item.id === 'toggle-kepler-dropdown' ? (keplerDropdownVisible || false) : ((item && item.items && item.items.dropdownVisible) || false);

        const badgeCount = item && item.id === 'toggle-collections'
            ? (collectionsCount || 0)
            : ((item && item.items && item.items.length) || 0);

        return {
            ...item,
            user,
            onItemSelected: selectToolbarItem,
            flags,
            badgeCount,
            buttonLabel,
            dropdownVisible
        };
    }
})(ButtonListItem);


let ToolbarItems = (
    { id, flags, name, renderPopover, popoverData, isPopoverOpen, items = [], selectToolbarItem, dataset, view, user, showCollections, showKepler, keplerMode, keplerDropdownVisible, collectionsCount } = {}
) => {
    const filteredItems = items.filter((item) => {
        if (!item) {
            return false;
        }
        if (item.id === 'toggle-collections' && !showCollections) {
            return false;
        }
        if (item.id === 'toggle-kepler-dropdown' && !showKepler) {
            return false;
        }
        return true;
    });

    if (filteredItems.length === 0) {
        return null;
    }

    return (
        <ButtonListItems id={id} name={name}>
            {filteredItems.map((item, index) => {
                return (
                    <ToolbarItem
                        data={item}
                        user={user}
                        flags={flags}
                        dataset={dataset}
                        view={view}
                        groupId={id}
                        popoverData={popoverData}
                        renderPopover={renderPopover}
                        isPopoverOpen={isPopoverOpen}
                        key={`${index}: toolbar-item-${item.id}`}
                        selectToolbarItem={selectToolbarItem}
                        keplerMode={keplerMode}
                        keplerDropdownVisible={keplerDropdownVisible}
                        collectionsCount={collectionsCount}
                    />
                );
            })}
        </ButtonListItems>
    );
};

ToolbarItems = container({
    renderLoading: false,
    fragment: ({ items } = {}) => {
        //console.debug({items}, '@ToolbarItems.container::fragment');
        return `{
            id, name, items: ${ToolbarItem.fragments(items)}
        }`;
    }
})(ToolbarItems);


let Toolbar = (
    { renderPopover, popoverData, isPopoverOpen, toolbar = [], selectToolbarItem, flags, dataset, view, user, showCollections, showKepler, keplerMode, keplerDropdownVisible, collectionsCount, ...props } = {}
) => {
    //TODO why is toolbar: {length: n, ...} passed in as {} instead of []?
    //maybe progressive loader: getting undefined items in this case
    if (!(toolbar instanceof Array)) {
        if (!toolbar) {
            return null;
        }
        if (toolbar.length) {
            const arr = new Array(toolbar.length);
            for (let i = 0; i < toolbar.length; i++) {
                arr[i] = toolbar[i];
            }
            toolbar = arr.filter(Boolean);
        } else {
            toolbar = [];
        }
    }

    return (
        <ButtonList {...props}>
            {toolbar.map((items, index) => {
                if (items.id === 'view' && !showKepler) {
                    return null;
                }
                return (
                    <ToolbarItems
                        flags={flags}
                        dataset={dataset}
                        view={view}
                        data={items}
                        user={user}
                        showCollections={showCollections}
                        showKepler={showKepler}
                        popoverData={popoverData}
                        renderPopover={renderPopover}
                        isPopoverOpen={isPopoverOpen}
                        key={`toolbar-items-${items.id}`}
                        selectToolbarItem={selectToolbarItem}
                        keplerMode={keplerMode}
                        keplerDropdownVisible={keplerDropdownVisible}
                        collectionsCount={collectionsCount}
                    />
                );
            }).filter(Boolean)}
        </ButtonList>
    );
};

Toolbar = container({
    renderLoading: false,
    fragment: (toolbar = []) => {
        //console.debug({toolbar}, 'Toolbar::fragment');
        return `{
            visible, ...${ToolbarItems.fragments(toolbar)}
        }`;
    },
    // map fragment to component props
    mapFragment: (toolbar = [], {user}) => {
        //console.debug({user, toolbar}, '@Toolbar::mapFragment');
        return {
            toolbar,
            user,
            visible: toolbar.visible
        };
    }
})(Toolbar);


export { Toolbar, ToolbarItems, ToolbarItem };
